// extracted by mini-css-extract-plugin
export default {"modalContainer":"Modal_modalContainer__J8roM","modalTitle":"Modal_modalTitle__Xt2G0","isSmall":"Modal_isSmall__1Eqqh"};